import React, { FC, memo } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { viewTexts } from '../../constants/view-texts';
import { useLoggedIn } from '../../global-state/auth-state';
import { routes } from '../../routing/routes';
import { MuiButton } from '../shared/form-element';
import { Root } from '../shared/styled/root';

const vt = viewTexts.pages.notFound;

const RootCentered = styled(Root)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Title = styled.div`
  padding: 10px;
`;

export const NotFoundPage: FC<{}> = memo(() => {
  const loggedIn = useLoggedIn();
  return (
    <RootCentered>
      <Title>{vt.title}</Title>
      {loggedIn === true ? (
        <Link to={routes.koumutenList}>
          <MuiButton label={vt.goToKoumutenList} />
        </Link>
      ) : (
        <Link to={routes.login}>
          <MuiButton label={vt.goToLogin} />
        </Link>
      )}
    </RootCentered>
  );
});

NotFoundPage.displayName = 'NotFoundPage';
